import { CalendarCheckIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CalendarTick = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarCheckIcon {...rest} size={Sizes[size]} color={fill} />;
};

CalendarTick.displayName = 'CalendarTick';
